export default __webpack_public_path__ + "static/media/senior-sample8.49fc5849.png";